import { takeLatest } from "redux-saga/effects";
import {
  GetAdditionalInfoWorker,
  UpdateAdditionalInfoWorker,
} from "./AdditionalInfoSagaWorkers";
import {
  GetAdditionalInfo,
  UpdateAdditionalInfo,
} from "../../StateManagement/Reducers/AdditionalInfoState";

export function* AdditionalInfoSagaWatchers() {
  yield takeLatest(GetAdditionalInfo.type, GetAdditionalInfoWorker);
  yield takeLatest(UpdateAdditionalInfo.type, UpdateAdditionalInfoWorker);
}
